<template>
  <div>
    <div v-if="datas.length > 0">
      <div v-for="(v, i) in datas" :key="i" class="item c-bg-white">
        <g-img-list :src="$root.defaultImg">
          <div class="r-box" @click="handleToCardInfoPage(v)">
            <div class="right-box">
              <div class="top c-main-txt">
                <span>余额: </span>
                <span class="c-yang">￥</span>
                <i>{{ v.allMoney }}</i>
              </div>
              <div class="bottom c-sub-txt c-font-20">
                <div>
                  <span> 卡种名称：</span>
                  <span>{{ v.CardTypeName }}</span>
                </div>
                <div>
                  <span> 会员卡号：</span>
                  <span>{{ v.CardCode }}</span>
                </div>
                <div>
                  <span> 有效期至：</span>
                  <span>{{ v.EndTime }}</span>
                </div>
                <div>
                  <span> 有效积分：</span>
                  <span>{{ v.Integral? v.Integral:0 }}</span>
                </div>
              </div>
            </div>
            <g-arrow></g-arrow>
          </div>
        </g-img-list>
        <g-line size="1"></g-line>
      </div>
    </div>
    <div v-else>
      <g-no-content title="暂无会员卡"></g-no-content>
    </div>
    <div class="footer">
      <div class="m-r-10 f-1">
        <van-button
          color="var(--tc)"
          plain
          round
          block
          @click="$router.push('/member/handleEleCard')"
          style="margin-bottom: 12px"
          >办理会员卡</van-button
        >
      </div>
      <div class="f-1">
        <van-button
          color="var(--tc)"
          block
          round
          @click="$router.push('/member/bindRealCard')"
          >实体卡绑定</van-button
        >
      </div>
    </div>
    <!-- <van-goods-action>
      <van-goods-action-button
        color="#fff"
        text="办理会员卡"
        @click="$router.push('/member/handleEleCard')"
      />
      <van-goods-action-button
        color="var(--tc)"
        @click="$router.push('/member/bindRealCard')"
        text="实体卡绑定"
      />
    </van-goods-action> -->
  </div>
</template>

<script>
import { handleSessionStorage } from "@/utils";
export default {
  name: "MyMemberCard",
  props: {},
  data() {
    return {
      datas: [],
    };
  },
  watch: {
    "$store.state.vpnId"(val) {
      this.vpnId = val;
      this.getList();
    },
  },
  created() {
    this.vpnId = this.$store.state.vpnId;
    if (this.vpnId) {
      this.getList();
    }
  },
  mounted() {},
  methods: {
    getList() {
      const params = {
        IsBindWx: true,
        VpnId: this.vpnId,
      };
      $http("wechath5/zh-cn/v1/member/list", params, "get").then((res) => {
        res.forEach((item) => {
          item.EndTime = item.EndTime ? item.EndTime.split(" ")[0] : "";
          item.StartTime = item.StartTime ? item.StartTime.split(" ")[0] : "";
          item.allMoney = item.DonationMoney + item.LeaveMoney;
        });
        this.datas = res;
        // this.datas = [
        //   {
        //     LeaveMoney: 11,
        //     CardCode: 8001,
        //     EndTime: "2030-12-31",
        //     Integral: 10,
        //   },
        // ];
      });
    },

    handleToCardInfoPage(item) {
        this.$router.push({
        name: "MembershipCardDetails",
        params: { MemberGuid: item.MemberGuid},
        query: {
          ...item
        },
      });
    },
  },
};
</script>
<style scoped lang="scss">
.r-box {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.right-box {
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: space-between;
  .bottom {
    > div {
      height: 40px;
      line-height: 40px;
    }
  }
}
.footer {
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 2;
  width: 100%;
  // min-height: 140px;
  border-top: 1px solid #eee;
  background: #fff;
  box-sizing: border-box;
  padding: 26px 32px 26px;
  display: flex;
  .submit_btn_con {
    display: flex;
    display: -webkit-flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
